<div [class.disabled-container]="isDisabled">
	<!-- Input checkbox -->
	<input
		#animatedCheckboxInput
		type="checkbox"
		[id]="id"
		class="inp-cbx"
		[(ngModel)]="value"
		(ngModelChange)="onSelected()"
		[name]="id"
		[disabled]="isDisabled"
	/>

	<!-- Label of checkbox for selecting a design -->
	<label
		class="cbx"
		[for]="id"
		ngGrowOnEvent
		[effectOptions]="{ event: EnumNgEventName.MouseKey }"
	>
		<span>
			<svg
				width="12px"
				height="9px"
				viewbox="0, 0 12, 9"
			>
				<polyline points="1, 5 4, 8 11, 1"></polyline>
			</svg>
		</span>
	</label>
</div>
